// extracted by mini-css-extract-plugin
export var wrapper = "open-position-list-module--wrapper--ed29d secondary-footer-module--blue--1bdf4 secondary-footer-module--wrapper--ce03e container-module--wrapper--c1517";